import { coreStakeholdersIdMapSlice } from './update';

export const updateStakeholderReferences = coreStakeholdersIdMapSlice.syncActionCreator;
